import React from "react";
const MenuLoader = (prop) => {
  return (
    <div className="menuloader">
      <div className="ui large loader"></div>
    </div>
  );
};

export default MenuLoader;
